import { createFileRoute } from "@tanstack/react-router";
import { EmptyState } from "@/components/app/lists/empty-state";
import { PageHeader } from "@/components/app/shell/page-header";
import { SettingsTab } from "@/routes/_authenticated/community/-components/settings-tab";
import { useCommunityBuilding } from "@/routes/_authenticated/community/-components/use-community-building";

export const Route = createFileRoute("/_authenticated/community/settings")({
  component: CommunitySettingsPage,
});

/** What families may do in the building's community, and how it is moderated. */
function CommunitySettingsPage() {
  const { building, canModerate, canManage } = useCommunityBuilding();
  if (!building) return null;
  return (
    <>
      <PageHeader title="Community settings" />
      {canModerate || canManage ? (
        <div className="max-w-150">
          <SettingsTab facilityId={building.id} canManage={canManage} />
        </div>
      ) : (
        <EmptyState
          title="Not open to you"
          description="Community settings are for the people who run the community at this building."
        />
      )}
    </>
  );
}
